export class ValidatieVoorTeVersterkenTreinModel {
  constructor(
    public treinnummer: number,
    public treinDatum: string,
    public dienstregelVersie: number,
  ) {}
}

export function mapValidatieVoorTeVersterkenTrein(
  rawModel: ValidatieVoorTeVersterkenTreinModel,
): ValidatieVoorTeVersterkenTreinModel {
  return new ValidatieVoorTeVersterkenTreinModel(rawModel.treinnummer, rawModel.treinDatum, rawModel.dienstregelVersie);
}
